import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const { user, logout } = useAuth();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const handleLogout = () => {
    setShowLogoutDialog(true);
  };

  const handleCancelLogout = () => {
    setShowLogoutDialog(false);
  };

  const handleConfirmLogout = () => {
    setShowLogoutDialog(false);
    logout();
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <h2>Outil de Traduction</h2>
      </div>

      <div className="navbar-links">
        <Link to="/" className={`nav-link ${isActive('/')}`}>
          Traduction
        </Link>
        <Link to="/logs" className={`nav-link ${isActive('/logs')}`}>
          Logs
        </Link>
      </div>

      <div className="navbar-user">
        <span className="user-name">{user?.name}</span>
        <button className="logout-btn" onClick={handleLogout}>
          Déconnexion
        </button>
      </div>

      {/* Dialogue de confirmation de déconnexion */}
      {showLogoutDialog && (
        <div className="logout-dialog-overlay" onClick={handleCancelLogout}>
          <div className="logout-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="logout-dialog-header">
              <h3>Confirmer la déconnexion</h3>
            </div>
            <div className="logout-dialog-body">
              <p>Êtes-vous sûr de vouloir vous déconnecter?</p>
            </div>
            <div className="logout-dialog-footer">
              <button className="btn-cancel" onClick={handleCancelLogout}>
                Annuler
              </button>
              <button className="btn-confirm" onClick={handleConfirmLogout}>
                Déconnexion
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
